import { Component, OnInit } from '@angular/core';
import { DashboardCustomerKPIService } from '../../../services';
import { EventService } from '../../../services';
import { ChartDataset } from '../../../interfaces/kpis/customer-kpi-totals';
import _ from 'lodash';

@Component({
  selector: 'dashboard-customer-kpi-summary',
  templateUrl: './dashboard-customer-kpi-summary.component.html',
  styleUrls: ['./dashboard-customer-kpi-display.component.scss'],
})
export class DashboardCustomerKPISummaryComponent implements OnInit {
  constructor(
    private dashboardKPIService: DashboardCustomerKPIService,
    private eventService: EventService,
  ) {}

  // pass to display component as Input
  metrics: any[];
  chartOptions: any;

  async ngOnInit() {
    this.eventService.CustomerKPIRefreshEvent.subscribe(() => {
      this.loadData();
    });

    // create copy of base chart options and modify label display to percent
    this.chartOptions = _.cloneDeep(this.dashboardKPIService.baseChartOptions);
    this.chartOptions.plugins.datalabels.formatter = (value, ctx) => {
      if (ctx.datasetIndex < 2) {
        let value1 = ctx.chart.data.datasets[2].data[ctx.dataIndex];
        if (value1 == 0) {
          return '0.0%';
        }
        let pv = (value / value1) * 100;
        let percentage = pv.toFixed(1) + '%';
        return percentage;
      } else {
        return value;
      }
    };
  }

  async loadData() {
    this.metrics = [];
    this.setSummaryMetric_Collection();
    this.setSummaryMetric_Delivery();
    console.log('Summary Metrics: ', this.metrics);
  }

  async setSummaryMetric_Collection() {
    let datas: ChartDataset[] = [
      {
        label: 'Completed',
        data: this.dashboardKPIService.completedTotals.map((x) => x.completedMoves),
        backgroundColor: 'rgba(66, 164, 245, 1)',
        type: 'bar',
      },
      {
        label: 'On Time Collection',
        data: this.dashboardKPIService.completedTotals.map((x) => x.onTimeCollection),
        backgroundColor: this.dashboardKPIService.gradeColours[5],
        type: 'line',
      },
      {
        label: '< 1 Hour Late (Collection)',
        data: this.dashboardKPIService.completedTotals.map((x) => x.lessThan1HourLateCollection),
        backgroundColor: this.dashboardKPIService.gradeColours[2],
        type: 'line',
      },
    ];

    let labels = this.dashboardKPIService.completedTotals.map((x) => x.dateLabel);
    let metric = this.dashboardKPIService.getServiceMetricData(
      'Summary (Collection)',
      datas,
      labels,
      false,
      this.chartOptions,
    );

    this.metrics.push(metric);
  }

  async setSummaryMetric_Delivery() {
    let datas: ChartDataset[] = [
      {
        label: 'Completed',
        data: this.dashboardKPIService.completedTotals.map((x) => x.completedMoves),
        backgroundColor: 'rgba(66, 164, 245, 1)',
        type: 'bar',
      },
      {
        label: 'On Time Delivery',
        data: this.dashboardKPIService.completedTotals.map((x) => x.onTimeDelivery),
        backgroundColor: this.dashboardKPIService.gradeColours[5],
        type: 'line',
      },
      {
        label: '< 1 Hour Late (Delivery)',
        data: this.dashboardKPIService.completedTotals.map((x) => x.lessThan1HourLateDelivery),
        backgroundColor: this.dashboardKPIService.gradeColours[2],
        type: 'line',
      },
    ];

    // filter out datas with no value
    //datas = this.dashboardKPIService.filterZeroData(datas);

    let labels = this.dashboardKPIService.completedTotals.map((x) => x.dateLabel);
    let metric = this.dashboardKPIService.getServiceMetricData(
      'Summary (Delivery)',
      datas,
      labels,
      false,
      this.chartOptions,
    );

    this.metrics.push(metric);
  }
}
